'use client'

import React from "react"
import Typography from "@mui/material/Typography";
import { StyledFootnote } from "./footnote.style";

export const Footnote = ({children, mt = 1, overhang, overhangVariant="inherit", variant="caption", ...props}) => {
  return (
    <StyledFootnote variant={variant} mt={mt} component="p" position="relative" {...props}>
      {overhang && <Typography variant={overhangVariant} component="span" className="overhang">{overhang}</Typography>}
      {children}
    </StyledFootnote>
  )
}